import React, { useState } from "react";
import { Divider, Tooltip } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import ButtonBackground from "images/button-background.svg";
import { ReactComponent as SendersIcon } from "images/providers-icon.svg";
import { ReactComponent as SendersActiveIcon } from "images/providers-active-icon.svg";
import * as FP from "utils/fp-js";
import { useReferralButton } from "./ReferralButton.hook";
import {
  ButtonContainer,
  ButtonIndicator,
  Container,
  Label,
  Led,
  LogoHolder,
  LogoSplash,
  Prop,
  TextMosaic,
  Value,
  Logo,
  EmptyLogoHolder,
  HalfHolder,
} from "./SmallReferralButton.style";
import { modes } from "./ReferralButton";
import { ReferralForm } from "./ReferralForm/ReferralForm";
import clsx from "clsx";
import { guideSteps } from "hooks/useOnboarding";

export const SmallReferralButton = ({
  data,
  setError,
  setCurrentButton = () => null,
  logo,
  mode,
  setNewLevel,
  setNewProgress,
  setNewCountsForUpdate,
  setLevelProgress,
  originator,
}) => {
  const [newReferral, setNewReferral] = useState(null);

  const {
    state,
    createNewReferral,
    handleReferralButtonClick,
    recipient,
    providers,
    isSendersSelected,
    isReferralSending,
  } = useReferralButton({
    data,
    setError,
    setNewLevel,
    setNewProgress,
    setNewCountsForUpdate,
    setLevelProgress,
    originator,
    setNewReferral,
  });

  return (
    <div
      className={clsx(
        guideSteps.BUTTON,
        guideSteps.BUTTON_QUESTION,
        "bg-white p-0 sm:p-8 border-0 sm:border-4 rounded-3xl border-dashed place-self-stretch flex flex-col justify-start items-center"
      )}
    >
      <Container>
        <ButtonContainer
          sx={{
            backgroundImage:
              logo && mode === modes.Skin
                ? `url("${logo}")`
                : `url("${ButtonBackground}")`,
          }}
        >
          {/* {!recipient?.isFlowSimplified && (
            <Stack
              alignItems={"flex-end"}
              sx={{
                margin: 0,
                position: "absolute",
                top: "-10px",
                right: "-10px",
              }}
            >
              <ActionMenu
                items={[
                  {
                    label: "View Details",
                    onClick: () => setSelectedButton(data[locationId]),
                  },
                ]}
              />
            </Stack>
          )} */}
          {FP.match(true)
            .on(
              mode === modes.Logo && !!logo,
              <Logo
                sx={{
                  backgroundImage: `url("${logo}")`,
                }}
              />
            )
            .on(
              mode === modes.Half && !!logo,
              <>
                <EmptyLogoHolder />
                <HalfHolder
                  sx={{
                    backgroundImage: `url("${logo}")`,
                  }}
                />
              </>
            )
            .otherwise(
              <>
                {logo ? (
                  <LogoSplash />
                ) : (
                  <LogoHolder>
                    <TextMosaic>
                      {[...Array(20)].map(() => recipient?.name).join(" ")}
                    </TextMosaic>
                  </LogoHolder>
                )}
              </>
            )}
          <Led className={state} />
          <ButtonIndicator onClick={createNewReferral} className={state}>
            {isReferralSending && <CircularProgress />}
          </ButtonIndicator>
        </ButtonContainer>
        {providers?.map(({ id, name, speciality }) => (
          <Prop key={`${id}-in-button`}>
            <Label>Provider: </Label>
            <Value>{[name, speciality].filter(Boolean).join(", ")}</Value>
          </Prop>
        ))}
        <Divider />
        <Prop>
          <Label>Practice: </Label>
          <Value>{recipient?.name}</Value>
        </Prop>
        <Prop>
          <Label>Phone: </Label>
          <Value>{recipient?.phone}</Value>
        </Prop>

        <Tooltip title={"Manage senders"}>
          <button
            onClick={() => setCurrentButton(data)}
            className="absolute -top-2 -left-1 w-7 h-7 p-1 bg-gray-200 rounded-full flex items-center justify-center hover:bg-gray-300 focus:outline-none"
          >
            {isSendersSelected ? <SendersActiveIcon /> : <SendersIcon />}
          </button>
        </Tooltip>
      </Container>
      {!!newReferral && (
        <ReferralForm
          newReferral={newReferral}
          setNewReferral={setNewReferral}
          handleReferralButtonClick={handleReferralButtonClick}
        />
      )}
    </div>
  );
};
